class OfferBannerOffer {
  constructor(data) {
    this.collectionId = data.collectionId;
    this.collectionSpend = data.collectionSpend;
    this.minimumSpend = data.minimumSpend;
    this.message = data.message;
    this.data = data;
  }
  get type() {
    return this.data.freeGiftVariantId != null ? 'freeGift' : 'spendX';
  }
  get minimumSpendCents() {
    return this.minimumSpend * 100;
  }
  get alredyQualified() {
    if (this.type == 'freeGift') {
      return this.collectionSpend >= this.minimumSpendCents && this.freeGiftInCart;
    }
    return this.collectionSpend >= this.minimumSpendCents;
  }
  get variantId() {
    return this.data.freeGiftVariantId;
  }
  get freeGiftInCart() {
    return this.data.freeGiftInCart;
  }
  getAddOnObject() {
    return {
      id: parseInt(this.variantId),
      quantity: 1,
      properties: {
        _auto_add_on: 'true',
      },
    };
  }
  getMessage() {
    let difference = this.minimumSpendCents - this.collectionSpend;
    if (difference < 0) {
      difference = this.minimumSpendCents;
    }
    return this.message.replace(
      '[[amount]]',
      `<span class='font-weight-semi-bold'>${this.formatMoney(difference / 100)}</span>`
    );
  }
  formatMoney(number) {
    let currency = Shopify.currency.active;
    let locale = Shopify.locale;
    let country = Shopify.country;
    let formatted = '';
    try {
      formatted = new Intl.NumberFormat(`${locale}-${country}`, {
        style: 'currency',
        currency: currency,
        trailingZeroDisplay: 'stripIfInteger',
      }).format(number);
    } catch (e) {
      console.error(e);
      formatted = `£${number.toFixed(2)}`;
    }
    return formatted;
  }
}

if (!customElements.get('offers-banner')) {
  customElements.define(
    'offers-banner',
    class OffersBanner extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.url = this.dataset.url;
        this.rawData = this.querySelector('[data-offers-data]');
        this.data = null;
        this.offers = [];
      }
      refreshData() {
        this.data = null;
        this.offers = [];
        fetch(`${this.url}?section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            let offersDataSource = html.querySelector('offers-banner');
            if (offersDataSource != null) {
              this.innerHTML = offersDataSource.innerHTML;
              this.getData();
            } else {
              this.classList.add('hidden');
            }
            this.loading = false;
          });
      }
      connectedCallback() {
        this.getData();
      }
      set loading(loadingState) {
        this._loading = loadingState;
        this.classList.toggle('loading', loadingState);
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.toggle('hidden', !loadingState);
        }
      }
      get messageElement() {
        return this.querySelector('[data-offer-message]');
      }
      get loadingSpinner() {
        return this.querySelector('.loading__spinner');
      }
      get loading() {
        return this._loading;
      }
      get hasOffer() {
        return this.offers.length > 0 && this.firstAvailableOffer != undefined;
      }
      get firstAvailableOffer() {
        let firstOffer = this.offers.find((offer) => !offer.alredyQualified);
        return firstOffer;
      }
      get willGetFreeGift() {
        return (
          this.hasOffer &&
          this.firstAvailableOffer.type == 'freeGift' &&
          this.firstAvailableOffer.collectionSpend + this.variantPrice >= this.firstAvailableOffer.minimumSpendCents
        );
      }
      get firstOfferMessage() {
        let message = '';
        if (this.defaultMessage != '') {
          message = this.defaultMessage;
        }
        if (this.variantMessage != null) {
          message = this.variantMessage;
        }
        if (this.firstAvailableOffer != undefined) {
          message = this.firstAvailableOffer.getMessage();
        }
        return message;
      }
      getData() {
        this.rawData = this.querySelector('[data-offers-data]');
        if (this.rawData == null) {
          return this.classList.add('hidden');
        }
        try {
          this.data = JSON.parse(this.rawData.innerText);
          this.parseData();
          this.generateMessage();
        } catch (e) {
          console.error(e);
          return this.classList.add('hidden');
        }
      }
      parseData() {
        this.collectionIds = this.data.collectionIds;
        this.variantPrice = this.data.variantPrice;
        this.defaultMessage = this.data.defaultMessage;
        this.variantMessage = this.data.variantMessage;
        this.offers = [];
        this.data.freeGiftOffers.forEach((offer) => {
          if (this.collectionIds.includes(offer.collectionId)) {
            this.offers.push(new OfferBannerOffer(offer));
          }
        });
        this.data.spendXGetYOffers.forEach((offer) => {
          if (this.collectionIds.includes(offer.collectionId)) {
            this.offers.push(new OfferBannerOffer(offer));
          }
        });
      }
      generateMessage() {
        let message = this.firstOfferMessage;
        if (message != '') {
          this.classList.remove('hidden');
        } else {
          this.classList.add('hidden');
        }
        this.messageElement.innerHTML = message;
      }
    }
  );
}
